/** 企業帳號 - 啟用狀態 */
export enum CorporateAccountStatus {
  /** 未驗證 */
  UNVERIFIED = '0',
  /** 已驗證 */
  VERIFIED = '1',
  /** 已停權 */
  SUSPENDED = '2'
}
